export default __webpack_public_path__ + "images/phone-new-message.1f2cea2fc126543b77ab4f136716c129.svg";